<template>
  <div>
    <div v-if="loading" class="loader"></div>
    <div v-else>
    <div class="row">
      <div class="col-md-6 text-left">
        <button type="button" :disabled="refreshNodesloading" @click="refreshNodes()" class="btn btn-primary">
          <div class="loader" v-if="refreshNodesloading" style="width: 15px;height: 15px; margin: 0 !important;"></div>
           <span v-else>Refresh</span>
        </button>
        <button type="button" @click="loadRackModal()" class="btn btn-primary">Add new node</button>
      </div>
      <div class="col-md-6 text-right">
        <button v-if="user.email === 'sara@bigscoots.com'" type="button" @click="syncNodesByDev()" class="btn btn-primary">
          <div class="loader" v-if="loading" style="width: 15px;height: 15px; margin: 0 !important;"></div>
          <span v-else>Sync Nodes By Dev</span>
        </button>
<!--        <button type="button" @click="syncNodesFromBash()" class="btn btn-primary">-->
<!--          <div class="loader" v-if="syncNodesLoader" style="width: 15px;height: 15px; margin: 0 !important;"></div>-->
<!--          <span v-else>Sync Nodes</span>-->
<!--        </button>-->
        <button v-if="user.email === 'sara@bigscoots.com'" type="button" @click="syncNodesInAccMonitor()" class="btn btn-primary">
          <div class="loader" v-if="syncDomainsLoader" style="width: 15px;height: 15px; margin: 0 !important;"></div>
          <span v-else>Sync across all Plans</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right mt-10">
<!--        <div class="form-group">-->
<!--          <label class="">Filter By</label>-->
<!--          <select class="form-control pt-5 pb-5 pl-5 pr-5" v-model="searchQuery">-->
<!--            <option value="" disabled selected>Select Filter By</option>-->
<!--            <option v-for="(search, index) in searchByFilter" :value="search.value" v-bind:key="index"> {{ search.name }}</option>-->
<!--          </select>-->
<!--        </div>-->
        <div class="dropdown m-auto">
          <button style="width: 17px!important; padding: 0!important; margin-right: 2px; height: 17px" class="wheel-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-filter fs-16"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton2">
            <a v-for="(search, index) in searchByFilter" v-bind:key="index" @click="searchQuery = search.value" :class="{'selected-background': searchQuery === search.value}" class="dropdown-item" href="javascript:void(0)" > {{ search.name }}</a>
          </div>
        </div>
      </div>
    </div>
    <table id="node" class="table table-bordered">
    <thead class="light">
    <tr>
      <th scope="col">Name</th>
      <th scope="col" class="text-center">Status</th>
      <th scope="col" class="text-center">IP</th>
      <th scope="col" class="text-center">Type</th>
      <th scope="col" class="text-center">Rack</th>
      <th scope="col" class="text-center">RAM(GB)</th>
      <th scope="col" class="text-center">CPU Cores</th>
      <th scope="col" class="text-center">Assigned</th>
      <th scope="col" class="text-center">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, index) in nodes" :key="index">
      <td>{{row.name || ''}}</td>
      <td class="text-center" style="text-transform: capitalize">
        <span class="badge badge-pill" :class="{'badge-success': row.status === 'active', 'badge-warning': row.role.id === 15, 'badge-default': row.status === 'offline', 'badge-danger': row.status === 'failed' && row.role.id !== 15}">{{ row.role.id === 15 ? 'Audit' : row.status || '' }}</span>
      </td>
      <td class="text-center">{{ row.ip || '' }}</td>
      <td class="text-center">{{(row.role ? row.role.display.split('Scoots - ')[1] : '')}}</td>
      <td class="text-center">{{row.rack ? row.rack.name : ''}}</td>
      <td class="text-center">{{`${row.ram} GB` || ''}}</td>
      <td class="text-center">{{`${row.cpu_cores} Cores` || 0}}</td>
      <td class="text-center">
        <template v-if="row.assigned">
          <a v-if="row.assigned.includes(' - ')" href="javascript:void(0)" @click="openHostingAccount(row)">{{row.assigned}}</a>
          <span v-else>
            {{row.assigned}}
          </span>
        </template>
        <span v-else>Unassigned</span>
      </td>
      <td class="text-center">
        <div class="dropdown m-auto">
          <button style="width: 16px!important; padding: 0!important; margin-right: 2px; height: 16px" class="wheel-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-cog"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton2">
            <a @click="viewNodeInfo(row)" class="dropdown-item" href="javascript:void(0)" >View Info</a>
            <a class="dropdown-item" target="_blank" :href="`https://netbox.ord-eng-mgr1.bscoots.dev/dcim/devices/${row.id}`">View Netbox</a>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <nodeInfoModal ref="nodeInfoModal"></nodeInfoModal>
  </div>
  </div>

</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import nodeInfoModal from "@/components/Admin/Dashboard/nodeInfoModal.vue";

export default {
  name: "nodes",
  components: {
    racksModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/racksModal"),
    nodeInfoModal
  },
  computed: {
    nodes(){
      let array = this.allNodes;
      if(this.searchQuery) {
        if(this.searchQuery === 'all') {
          array = this.allNodes;
        } else if(this.searchQuery === 'wpo'){
          array = this.allNodes.filter(el => el.solusvm_node_id);
        } else if(this.searchQuery === 'scoots-wpo') {
          array = this.allNodes.filter(el => el.role.id === 14);
        }else if(this.searchQuery === 'scoots-shared') {
          array = this.allNodes.filter(el => el.role.id === 11);
        }else if(this.searchQuery === 'scoots-vps') {
          array = this.allNodes.filter(el => el.role.id === 12);
        }else if(this.searchQuery === 'scoots-audit') {
          array = this.allNodes.filter(el => el.role.id === 15);
        }else if(this.searchQuery === 'scoots-dedicated') {
          array = this.allNodes.filter(el => el.role.id === 10);
        }else if(this.searchQuery === 'unoccupied') {
          array = this.allNodes.filter(el => el.status === 'offline' && el.role.id !== 11 ); // not shared and status offline
        }else if(this.searchQuery === 'occupied') {
          array = this.allNodes.filter(el => el.assigned ); // not shared and status offline
        }
      }
      // console.log('array at 137', JSON.stringify(array.filter(el => el.status === 'active' && el.assigned && el.assigned.toLowerCase().includes('non-wpo') && !el.assigned.toLowerCase().includes('null'))))
      return array;
    }
  },
  watch: {
    nodes() {
      this.renderDatatable()
    }
  },
  data(){
    return {
      searchByFilter: [
        { name: 'All Nodes', value: 'all'},
        // { name: 'WPO Nodes', value: 'wpo'},
        { name: 'Scoots - WPO', value: 'scoots-wpo'},
        { name: 'Scoots - Shared', value: 'scoots-shared'},
        { name: 'Scoots - VPS', value: 'scoots-vps'},
        { name: 'Scoots - Dedicated', value: 'scoots-dedicated'},
        { name: 'Scoots - Audit', value: 'scoots-audit'},
        { name: 'Occupied Nodes', value: 'occupied'},
        { name: 'Likely Unoccupied Nodes', value: 'unoccupied'},
      ],
      searchQuery: 'all',
      allNodes: [],
      allRacks: [],
      nodeInfo: {},
      rackInfo: {},
      loading: false,
      syncNodesLoader: false,
      syncDomainsLoader: false,
      refreshNodesloading: false,
    }
  },
   mounted() {
     this.getAllNodes()
     this.renderDatatable()
  },
  methods: {
    async openHostingAccount(row) {
      try {
        console.log('rowwwww', row)
        const ref = await db.collection('domains').where('ip', '==', row.ip).limit(1).get();
        console.log('reffffffff', ref.docs[0].data())
        if(ref.size) {
          const { uid } = ref.docs[0].data();
          this.$router.push({ name: 'editUser', params: { docID: uid } })
        }
      }catch (e) {
        console.log('something happened', e.toString())
      }
    },
    viewNodeInfo(node) {
      this.$refs.nodeInfoModal.load(node)
    },
    handleSelectingOfRack(e) {
      console.log('eeeeeeeeee', e.targets)
    },
    async updateNodeInfo(){
      try {
        console.log('this', this.rackInfo)
        let id=this.nodeInfo.id
        delete this.nodeInfo.id
        if(this.rackInfo) {
          this.nodeInfo.rackId = this.rackInfo.id
          this.nodeInfo.rack_name = this.rackInfo.name
        } else {
          this.nodeInfo.rackId = ''
          this.nodeInfo.rack_name = ''
        }
        this.loading=true
        await db.collection('nodes').doc(id).set(this.nodeInfo)
        this.nodeInfo.id=id
        this.loading=false;
        this.nodeInfo={}
        swal({
          title: "Success",
          text: "Node info has been created successfully updated!",
          type: "success",
        });
        $("#nodeModal").modal("hide");

      }
      catch(err){
        this.loading=false;
        this.nodeInfo={}

        swal({
          title: "Error",
          text: "Error while updating node info " ,
          type: "error",
        });
        $("#nodeModal").modal("hide");

      }

    },
    async deleteNode(row){
      try{
        swal({
          title: "Delete Node",
          text: "Are you sure you want to delete node?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async result =>  {
          if(result.value){

            this.loading=true
            await db.collection('nodes').doc(row.id).delete()

            await this.getAllNodes();
            this.loading=false
            swal({
              title: "Success",
              text: "You have successfully deleted node  " ,
              type: "success",
            });
          }
        }).catch((err)=>{
          console.log('error', err)
          this.loading=false
          swal({
            title: "Error",
            text: "Error while deleting nodes " ,
            type: "error",
          });
        });
      }
      catch(err){
        this.loading=false
        swal({
          title: "Error",
          text: "Error while un-assigning nodes " ,
          type: "error",
        });
        $('#nodesModal').modal('hide');
      }

    },
    loadRackModal(){
      this.$parent.$refs.racks.load('node')
    },
    async openModal(row){
      this.nodeInfo={}
      this.nodeInfo=row
      await this.getAllRacks(row)
      $("#nodeModal").modal("show");

    },
    async getAllRacks(row){
      console.log(this.nodes.find(el1 => el1.nodeId === row.nodeId))
      const rackResp= await db.collection('racks').get();
      rackResp.forEach(el => {
          this.allRacks.push({id: el.id, ...el.data(), isDisabled: false, isSelected: el.id === row.rackId});
      })
      this.rackInfo = this.allRacks.find(el1 => el1.id === row.rackId) || null
      console.log(this.rackInfo)
    },
    renderDatatable() {
      console.log('rendering')
      if($.fn.DataTable.isDataTable('#node')) {
        $(`#node`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#node`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: true,
          "bInfo" : false,
          "ordering": true,
          "columnDefs": [
            { "orderable": false, "targets": [8] } // Disable sorting on the first and third columns
          ]
        });
      }, 0)
    },
    async refreshNodes(){
      try{
        this.refreshNodesloading=true
        await this.$http.post('/solus-vm/get_node_details', {
          grant_type: 'token',
          nodeId: 19
        })
        await this.getAllNodes()
        swal({
          title: "Success",
          text: "You have successfully refreshed nodes' data",
          type: "success",
        });
      }catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while refreshing node data",
          type: "error",
        });
      }
      finally {
        this.refreshNodesloading=false
      }
    },
    async syncNodesByDev() {
      try {
        this.loading = true;
        const response = await this.$http.post('/solus-vm/fetch_nodes_from_netbox', {
          grant_type: 'token'
        })
        console.log('response from api', response.data)
      } catch (e) {
        console.log('error while sync nodes', e.toString())
      } finally {
        this.loading = false
      }
    },
    async syncNodesFromBash(){
      try{
        this.syncNodesLoader=true
        await this.$http.post('/solus-vm/sync_nodes_from_server', {
          grant_type: 'token',
        })
        await this.getAllNodes()
        swal({
          title: "Success",
          text: "You have successfully synchronized nodes' data",
          type: "success",
        });
      }catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while synchronizing node data",
          type: "error",
        });
      }
      finally {
        this.syncNodesLoader=false
      }
    },
    async syncNodesInAccMonitor(){
      try{
        this.syncDomainsLoader = true
        await this.$http.post('/solus-vm/sync_nodes_for_all_plans', {
          grant_type: 'token',
        })
        swal({
          title: "Request Received!",
          text: "We are working on synchronising node info in domains and monitors",
          type: "success",
        });
      }catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while synchronizing nodeId in domains and monitors",
          type: "error",
        });
      }
      finally {
        this.syncDomainsLoader=false
      }
    },
    async getAllNodes(){
      console.log('nodes func called')
      try{
        this.loading=true
        let nodesResp=await  db.collection('netboxNodes').get()
        this.allNodes= []
        nodesResp.forEach( el => {
          this.allNodes.push({id:el.id, ...el.data()})
        })
        console.log('all nodes',this.allNodes)
        // await this.renderDatatable()
      }catch(e){
        console.log('error', e.toString())
      }
      finally {
        this.loading=false
      }
    },
  }
}
</script>

<style scoped>
.badge-default {
  background-color: #f0f0f0;
  color: #9d98a8;
  border: none;
}
.badge-success {
  background-color: #c6ffea;
  color: #57d364;
  border: none;
}
.badge-warning {
  background-color: #fff5e1;
  color: #e9bb36;
  border: none;
}
.badge-danger {
  background-color: #feeeee;
  color: #c52727;
  border: none;
}
.light{
  background-color: #f2f2f2 !important;
}

.wheel-btn, .wheel-btn:active, .wheel-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.wheel-btn:hover {
  background-color: black!important;
  color: white !important;
}
.dropdown-toggle:after {
  display: none;
}
.selected-background{
  background: black;
  color: white;
}
th{
  padding-right: 7px !important;
}
</style>
